import React from 'react'
import _ from 'lodash'
import { Tooltip, OverlayTrigger, Radio, Checkbox } from 'react-bootstrap'
import FormGroup from 'live/components/forms/ui/form-group'
import Select from 'live/components/forms/ui/select'
import i18n from 'live/services/i18n'

class FormItem extends React.Component {

    constructor (props) {
        super(props)
        this.state = {
            data: props.data || {},
            errorsFor: []
        }

        if (typeof this.props.onChange == 'function')
            this.__onChange = _.debounce(function (index, data, errors, removing) {
                this.props.onChange(index, data, errors, removing)
            }.bind(this), 200)

        this.onClick = this.onClick.bind(this)
    }

    UNSAFE_componentWillReceiveProps (props) {
        this.setState({
            data: props.data || {}
        })
    }

    onChange (e) {
        this.updateData(e.target.name, e.target.value)
    }

    updateData (field, value) {
        let index = this.props.index
        let fields = this.props.fields

        let data = _.clone(this.state.data)
        let errorsFor = []

        data[field] = value

        _.map(fields, (f) => {
            if (f.required && !data[f.name])
                errorsFor.push(f.name)

            if (typeof f.validation === 'function')
                if (!f.validation(f.name, data[f.name], data))
                    errorsFor.push(f.name)

        })

        this.setState({data, errorsFor})

        if (typeof this.__onChange == 'function')
            this.__onChange(index, data, errorsFor.length != 0, false)
    }

    clearItem () {
        let index = this.props.index
        let data = (this.state.data)

        _.map(data, (val, i) => {
            delete data[i]
        })

        this.setState({data})

        if (typeof this.props.onChange == 'function')
            this.props.onChange(index, data, false, true)
    }

    onClick () {
        let { data, index, onEdit} = this.props

        onEdit(index, data)
    }

    render () {
        let state = this.state
        let stateData = state.data
        let errorsFor = state.errorsFor
        let {hasFeedback, fields, cols, data, index, hasClear, onEdit, hasMoreRows} = this.props
        let hasData = typeof data !== 'undefined' && !_.isEmpty(data)
        let allowEdit = typeof onEdit == 'function'
        let clearItem = this.clearItem.bind(this)

        let required = {area: true, installationType: true, pentagonCoefficient: true, rigType: true}

        return (
            <div className={'item ' + (allowEdit ? 'editable' : '')}>
                {_.map(fields, (field, i) => {
                    let cls = `subitem col-md-${(field.cols || cols)} ${field.align || ''}`
                    let hasError = hasFeedback && (errorsFor.indexOf(field.name) != -1)

                    let shouldNotEdit = false

                    if (field.name == 'pentagonCoefficient' && (!(stateData['area'] == 'AUP' || stateData['area'] == 'EXP') && stateData['installationType'] == 'fixed'))
                        shouldNotEdit = 'Não se aplica'
                    else if (field.name == 'installationType' && (stateData['area'] == 'AUP' || stateData['area'] == 'EXP'))
                        shouldNotEdit = 'Flutuante'

                    if (stateData['activeOnSupervisorManagementRule'])
                        if (!shouldNotEdit && required[field.name] && (stateData[field.name] === '' || stateData[field.name] === undefined || stateData[field.name] === null)) {
                            hasError = true
                        }

                    return (
                        <div key={i} className={cls}
                            onClick={allowEdit && field.type == 'readonly' ? this.onClick : null}>
                            {field.type == 'select' && !shouldNotEdit
                                ? <Select placeholder={field.placeholder}
                                    value={stateData[field.name]}
                                    className="Select-small"
                                    options={field.options}
                                    onChange={this.updateData.bind(this, field.name)}
                                    validationState={hasError ? 'error' : 'success'}
                                    disabled={shouldNotEdit ? 'disabled' : false}
                                    clearable={field.clearable || false}
                                    searchable={field.searchable || false} />
                                : field.type == 'component'
                                    ? <field.Component onChange={this.updateData.bind(this)}
                                        value={stateData[field.name]}
                                        data={stateData}
                                        hasError={hasError}/>
                                    : field.type == 'readonly'
                                        ? typeof stateData[field.name] == 'string'
                                            ? <span className='text'>{stateData[field.name]}</span> : stateData[field.name]
                                        : field.type == 'radio-group'
                                            ? <div className="radio-group">
                                                {_.map(field.values, (radioObj) => {
                                                    return (
                                                        <Radio type="radio"
                                                            key={radioObj.value}
                                                            checked={radioObj.value == stateData[field.name]}
                                                            onChange={() => this.updateData(field.name, radioObj.value)}>
                                                            {radioObj.label}
                                                        </Radio>
                                                    )
                                                })}
                                            </div>
                                            : field.type == 'toggle'
                                                ? <a className={'btn-toggle ' + (stateData[field.name] ? 'on' : 'off')}
                                                    onClick={() => {
                                                        this.updateData(field.name, !stateData[field.name])
                                                    }}>
                                                    <span className="on">on</span>
                                                    <span className="off">off</span>
                                                </a>
                                                : field.type === 'checkbox'
                                                    ? <Checkbox checked={stateData[field.name] || false}
                                                        value={stateData[field.name] || false}
                                                        onChange={({target}) => this.updateData(field.name, target.checked)} />
                                                    : <FormGroup type={shouldNotEdit ? 'text' : field.type}
                                                        name={field.name}
                                                        placeholder={field.placeholder}
                                                        value={shouldNotEdit || stateData[field.name]}
                                                        disabled={shouldNotEdit ? 'disabled' : false}
                                                        onChange={this.onChange.bind(this)}
                                                        onFocus={this.props.onFocus}
                                                        validationState={hasError ? 'error' : 'success'}
                                                        hasFeedback help={hasError ? i18n('Required') : null}
                                                    />
                            }
                        </div>
                    )
                })}

                <div className="btn-actions">
                    {(hasClear && (hasData || hasMoreRows))
                        ? <a className="btn-clear" onClick={clearItem}>
                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="clear">{i18n('clear')}</Tooltip>}>
                                <i className="fa fa-trash-o"/>
                            </OverlayTrigger>
                        </a> : ''}

                    {hasData && allowEdit
                        ? <a className="btn-edit" onClick={() => { onEdit(index, data) }}>
                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="clear">{i18n('edit')}</Tooltip>}>
                                <i className="fa fa-edit"/>
                            </OverlayTrigger>
                        </a> : ''}
                </div>
            </div>
        )
    }

}

class RigSupervisorsTableForm extends React.Component {

    constructor (props) {
        super(props)

        this.state = {
            visibleRows: this.props.visibleRows,
            data: this.props.data || [],
            errorsFor: []
        }

        this.addField = this.addField.bind(this)
    }

    UNSAFE_componentWillReceiveProps (props) {
        this.setState({data: props.data})
    }

    addField () {
        let { onAdd } = this.props

        if (typeof onAdd === 'function') {
            onAdd()

            return
        }

        let data = this.state.data
        let dataLength = data.length || 0
        let visibleRows = this.state.visibleRows

        if (dataLength <= visibleRows) {
            visibleRows++
            this.setState({visibleRows})
        } else {
            dataLength++
            this.setState({visibleRows: dataLength})
        }
    }

    getErrors (index, error) {
        let errorsFor = _.clone(this.state.errorsFor)

        if (error) {
            if (errorsFor.indexOf(index) == -1)
                errorsFor.push(index)
        } else {
            if (errorsFor.indexOf(index) != -1)
                errorsFor.splice(errorsFor.indexOf(index), 1)
        }

        return errorsFor
    }

    getVisibleRows (data) {
        let visibleRows = _.clone(this.state.visibleRows)

        if (_.isEmpty(data))
            if (this.state.visibleRows - 1 >= this.props.visibleRows)
                visibleRows -= 1

        return visibleRows
    }

    onChange (index, data, error, removing) {
        let fullData = _.clone(this.state.data)
        var finalData = []
        let visibleRows = this.getVisibleRows(data)
        let errorsFor = this.getErrors(index, error)

        if (removing) {
            if (_.isEmpty(data))
                fullData.slice(index, 1)
            else
                fullData[index] = data

            _.map(fullData, (d) => {
                if (!_.isEmpty(d)) finalData.push(d)
            })
        } else {
            fullData[index] = data
            finalData = fullData
        }

        this.setState({
            data: finalData,
            errorsFor: errorsFor,
            visibleRows: visibleRows
        })

        if (typeof this.props.onChange == 'function')
            this.props.onChange(finalData, errorsFor.length != 0)
    }

    onFocus () {
        if (typeof this.props.onFocus == 'function')
            this.props.onFocus()
    }

    render () {
        let data = this.state.data
        let dataLength = 0
        let maxOrder = 0

        let fields = this.props.fields
        let fieldsLength = fields.length
        let cols = parseInt(12 / fieldsLength)

        cols = (cols >= 1) ? cols : 1
        let rows = []
        let hasClear = typeof this.props.hasClear != 'undefined' ? this.props.hasClear : true

        _.map(data, (d) => {
            if (typeof d != 'undefined') {
                dataLength++

                if (typeof d.order == 'number')
                    maxOrder = d.order > maxOrder ? d.order : maxOrder
            }
        })

        let visibleRows = this.state.visibleRows
        let maxItemsToShow = Math.max(maxOrder + (visibleRows == 0 ? 0 : 1), dataLength)
        let rowsToShow = visibleRows >= maxItemsToShow ? visibleRows : maxItemsToShow
        let hasFeedback = this.props.hasFeedback
        let className = this.props.className
        let addButtonLabel = this.props.addButtonLabel
        let addButtonDisabled = typeof this.props.addButtonDisabled != 'undefined' ? this.props.addButtonDisabled : false
        let hideAddButton = this.props.hideAddButton

        for (let i = 0; i < rowsToShow; i++)
            rows.push(<FormItem key={i}
                index={i}
                fields={fields}
                data={data[i] || null}
                cols={cols}
                hasClear={hasClear}
                hasMoreRows={rowsToShow > this.props.visibleRows}
                hasFeedback={hasFeedback}
                onEdit={this.props.onEdit}
                onChange={this.onChange.bind(this)}
                onFocus={this.onFocus.bind(this)}/>)

        return (
            <div className={'table-form ' + (className || '')}>
                <div className="header">
                    {_.map(fields, (field, i) => {
                        let cls = `subitem col-md-${(field.cols || cols)} ${field.align || ''}`

                        return (
                            <div key={i} className={cls}>
                                {i18n(field.label)}&nbsp;
                                {field.help ? <OverlayTrigger placement="bottom" overlay={<Tooltip id="help">{i18n(field.help)}</Tooltip>}>
                                    <i className="fa fa-question"/>
                                </OverlayTrigger> : null}
                            </div>
                        )
                    })}
                </div>

                <div className="body">{rows}</div>

                {!hideAddButton
                    ? <button className="btn" onClick={this.addField} disabled={addButtonDisabled}>
                        {addButtonLabel || <span>+ {i18n('add line')}</span>}
                    </button> : ''}
            </div>
        )
    }

}

module.exports = RigSupervisorsTableForm
